import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hover-title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row-checkbox" }
const _hoisted_4 = { class: "checkbox-container" }

import CheckboxGeneralDropdown from '../selectors/DropdownDashboard/Checkbox/CheckboxGeneralDropdown.vue'
import TooltipGeneral from '../TooltipGeneral.vue'
import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonSquareHoverCheckbox',
  props: {
    checkboxData: {}
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const showHoverExplanationText = ref(false)
const trackPointerEvent = ref<MouseEvent | null>(null)
function onHover(event: MouseEvent) {
  if (!props.checkboxData.disabled) return
  const targetEl = event.target as HTMLElement
  if (targetEl.offsetWidth < targetEl.scrollWidth) showHoverExplanationText.value = true
}
function onLeave() {
  showHoverExplanationText.value = false
  trackPointerEvent.value = null
}
function onToggle(id: string) {
  emits('toggle', id)
}
function trackPointer(event: MouseEvent) {
  if (!props.checkboxData.disabled) return
  trackPointerEvent.value = event
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "hovered-button",
    onMouseleave: onLeave,
    onMousemove: trackPointer,
    onMouseover: onHover
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["hover-header", { 'hover-header-disabled': _ctx.checkboxData.disabled }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.checkboxData.types && !_ctx.checkboxData.types.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "➥ "))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.checkboxData.title), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(CheckboxGeneralDropdown, {
            id: _ctx.checkboxData.id,
            class: _normalizeClass({ 'disabled-checkbox': _ctx.checkboxData.disabled }),
            checked: _ctx.checkboxData.visible,
            onToggle: onToggle
          }, null, 8, ["id", "class", "checked"])
        ])
      ])
    ], 2),
    (showHoverExplanationText.value)
      ? (_openBlock(), _createBlock(TooltipGeneral, {
          key: 0,
          title: 
        _ctx.checkboxData.disabledHoverExplanationText ? _ctx.checkboxData.disabledHoverExplanationText : ''
      ,
          pointerEvent: trackPointerEvent.value
        }, null, 8, ["title", "pointerEvent"]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})